import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { CompositionCardSkeleton } from '../composition-card/CompositionCardSkeleton';

const SKELETON_CARD_COUNT = 8;

/**
 * Loading skeleton for the compositions grid (matches card grid layout).
 */
export function CompositionsGridSkeleton() {
  return (
    <Box>
      <Grid container spacing={2}>
        {Array.from({ length: SKELETON_CARD_COUNT }).map((_, i) => (
          <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }} key={i}>
            <CompositionCardSkeleton />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
